import { isTauri } from "@tauri-apps/api/core"

/**
 * Whether this page is actually running inside a Tauri webview (`tauri dev`/a bundled app) as
 * opposed to a plain browser tab. Every direct `@tauri-apps/api/*` call outside the
 * `~/lib/tauriInvoke` choke point (window/event/opener APIs used for desktop-only features like
 * the debug window, the updater toast, or the escape-key call-minimize shortcut) must be guarded
 * by this — those APIs assume `window.__TAURI_INTERNALS__` exists and throw/hang without it.
 */
export function isTauriRuntime(): boolean {
  return typeof window !== "undefined" && isTauri()
}

/**
 * Desktop macOS (Tauri or a browser tab). iPadOS also reports "Macintosh" in its user agent —
 * touch points tell it apart.
 */
export function isMacOSDesktop(): boolean {
  return typeof navigator !== "undefined"
    && /Macintosh/.test(navigator.userAgent)
    && navigator.maxTouchPoints === 0
}
